import { OrganizationSwitcher, UserButton } from '@clerk/clerk-react';

import { FC } from 'react';
import SearchButton from './SearchButton';

interface ProjectsTopBarProps {
    onNewProject?: () => void;
    onOpenProject?: () => void;
    onOpenPreview?: () => void;
}

const ProjectsTopBar: FC<ProjectsTopBarProps> = ({
    onNewProject,
    onOpenProject,
    onOpenPreview,
}) => {
    return (
        <div className="flex items-center justify-between h-12 px-4 shrink-0 border-b border-gray-200">
            <div className="flex items-center">
                <div className="flex items-center">
                    <a href="https://preswald.com" target="_blank" rel="noopener noreferrer">
                        <img src="/symbol.png" alt="Logo" className="mr-2 h-6 w-auto" />
                    </a>
                    <span className="text-gray-400 font-light">/</span>
                </div>
                <OrganizationSwitcher 
                    hidePersonal
                    hideSlug
                    afterCreateOrganizationUrl={org => `/${org.slug}`}
                    afterLeaveOrganizationUrl="/"
                    afterSelectOrganizationUrl={org => `/${org.slug}`}
                    organizationProfileMode="navigation"
                    organizationProfileUrl="/settings/organization"
                />
            </div>
            <div className="flex items-center gap-1">
                <SearchButton
                    onNewProject={onNewProject}
                    onOpenProject={onOpenProject}
                    onOpenPreview={onOpenPreview}
                />
                <div className="h-7 w-7 flex items-center justify-center">
                    <UserButton 
                        afterSignOutUrl="/sign-in"
                        userProfileMode="navigation" 
                        userProfileUrl="/settings/account"
                        signInUrl='/sign-in'
                    />
                </div>
            </div>
        </div>
    );
};

export default ProjectsTopBar; 